import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../../../utils/EllowUtils'
import DashboardHeader from '../../dashboardHeader'
import SideMenu from '../../sideMenu'
import Styles from "../../styles.module.scss"
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import AppliedJobsList from './appliedJobs'
import { getAppliedJobs } from './services'



function AppliedJobs() {
    
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 6)
    const loginId: string = localStorage.getItem('loginId') || ''
    // const candidateId = localStorage.getItem('candidateid') || ''
    const [appliedJobsData, setAppliedJobsData] = useState<any>()

  useEffect(() => {
  
    getAppliedJobsByCandidate(loginId)
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
    
    const getAppliedJobsByCandidate = (candidateId: string) => {
        getAppliedJobs(candidateId).then((response) => {
            if (response && response.status === 1) {
                setAppliedJobsData(response.data)
           }          
        })
    }

  return (
      <div>
           <section className={Styles.dashboardWrapper}>
            <SideMenu menu={menu} />
            <div className={Styles.dashboardContent}>
                  <DashboardHeader title={'Applied Jobs'} />
                  <AppliedJobsList data={appliedJobsData} />
              </div>
         </section>
    </div>
  )
}

export default AppliedJobs